module.exports = __webpack_public_path__ + "omlazeni-pleti_1_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/laserova-estetika/omlazeni-pleti_1_after.jpg
// module id = 1013
// module chunks = 0